"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EyeSlashSolid: function() {
        return EyeSlashSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const EyeSlashSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M2.70711 1.29289C2.31658 0.902369 1.68342 0.902369 1.29289 1.29289C0.902369 1.68342 0.902369 2.31658 1.29289 2.70711L21.2929 22.7071C21.6834 23.0976 22.3166 23.0976 22.7071 22.7071C23.0976 22.3166 23.0976 21.6834 22.7071 21.2929L19.0765 17.6623C20.8738 16.3129 22.2435 14.4588 22.9499 12.3127C23.0167 12.1096 23.0167 11.8905 22.9499 11.6874C21.4754 7.20778 17.1112 4 12 4C10.0799 4 8.26527 4.45268 6.66962 5.25541L2.70711 1.29289ZM9.94246 8.52825L11.4739 10.0596C11.6408 10.0208 11.8166 10 11.9994 10C13.2281 10 14.1433 10.9391 14.1433 12C14.1433 12.2145 14.1059 12.424 14.0361 12.6218L15.5231 14.1089C15.915 13.5012 16.1433 12.781 16.1433 12C16.1433 9.74722 14.2434 8 11.9994 8C11.2574 8 10.553 8.19105 9.94246 8.52825Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M3.44735 7.66162C2.37416 8.80914 1.54765 10.1758 1.05013 11.6873C0.98329 11.8904 0.983289 12.1095 1.05013 12.3126C2.52458 16.7922 6.88883 20 12 20C13.1524 20 14.2668 19.8369 15.3187 19.533L11.7802 15.9944C9.65624 15.8862 7.89386 14.2156 7.85609 12.0704L3.44735 7.66162Z",
            fill: "currentColor"
        })
    ]
}), "EyeSlashSolid");
const _default = EyeSlashSolid;
